/*
 * @Author: 王枫叶
 * @Date: 2020-09-28 16:52:13
 * @LastEditors: 王枫叶
 * @LastEditTime: 2020-09-30 18:00:06
 */
import AvCommentConfig from "../views/avcomment/avCommentConfig";
import AvCommentList from "../views/avcomment/list";
import Main from "../views/main";
const ShuiguoRouter = {
  path: "/avcomment-list",
  component: Main,
  title: "AV图文管理",
  icon: "el-icon-user-solid",
  meta: { keepAlive: true },
  children: [
    {
      path: "/avcomment-list",
      component: AvCommentList,
      name: "avCommentList",
      title: "AV图文列表",
      meta: { title: "AV图文列表", keepAlive: false },
    },
    {
      path: "/avcomment-config",
      component: AvCommentConfig,
      name: "avCommentConfig",
      title: "AV图文配置",
      meta: { title: "AV图文配置", keepAlive: false },
    },
  ],
};
export default ShuiguoRouter;
